import * as yup from 'yup';
import { DocumentSection } from '../../../../slices/marketplace/timeline/models/document-section.model';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
export class MarketplaceDocumentSectionFieldValidator {
    static documentSectionValidationRules = (
        documentSections: DocumentSection[],
        party: TimelineParty
    ) => {
        let schema = yup
            .string()
            .required('Document section is required')
            .notOneOf(['-1'], 'Document section is required');

        if (party === TimelineParty.Buyer) {
            schema = schema.test(
                'is-available-for-buyers',
                'Selected section is not available for buyers',
                function (value) {
                    if (!value) return false;
                    const section = documentSections.find(
                        (s) => s.id === value
                    );
                    return section?.isAvailableForBuyers === true;
                }
            );
        }

        return schema;
    };
}
